'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (before, after) {
  var a = _matrix.getSquareToQuad.apply(null, after);
  var b = _matrix.getSquareToQuad.apply(null, before);
  var c = (0, _matrix.multiply)((0, _matrix.getInverse)(a), b);
  return this.matrixWarp(c);
};

var _matrix = require('../../matrix');


//////////////////
// WEBPACK FOOTER
// ./node_modules/glfx-es6/es/filters/warp/perspective.js
// module id = 268
// module chunks = 0